import React from 'react';
import { StyledImage, StyledImageContainer, StyledThumbnailDiv } from './styles';
import { isThumbnailImageEqual } from './services';
export function areFileUploadListItemThumbnailEqual(previousThumbnail, nextThumbnail) {
    return isThumbnailImageEqual(previousThumbnail.thumbnail, nextThumbnail.thumbnail);
}
const FileUploadListItemThumbnailInternal = ({ thumbnail }) => {
    const imageUrl = typeof thumbnail === 'string' || !thumbnail ? thumbnail : URL.createObjectURL(thumbnail);
    return (React.createElement(StyledThumbnailDiv, null,
        React.createElement(StyledImageContainer, null,
            React.createElement(StyledImage, { src: imageUrl }),
            ' ')));
};
export const FileUploadListItemThumbnail = React.memo(FileUploadListItemThumbnailInternal, areFileUploadListItemThumbnailEqual);
//# sourceMappingURL=FileUploadListItemThumbnail.js.map